export const processRefund = async ({
  price,
  id,
  refundReasons,
  mediaUrls,
  type,
  userName,
  userPhone,
  productName,
}: any) => {
  const req = await fetch('https://gibnkggiuxphkienkxwf.supabase.co/functions/v1/process-refund', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdpYm5rZ2dpdXhwaGtpZW5reHdmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzA3OTI0OTEsImV4cCI6MjA0NjM2ODQ5MX0.jzHj8vjuo7KuX4nHi-_tq051mp9quUNKMP0wN8Makj4`, // Замените YOUR_ACCESS_TOKEN на ваш токен
    },
    body: JSON.stringify({
      amount_cents: price,
      order_id: id,
      refund_reasons: refundReasons,
      media_urls: mediaUrls,
      type,
      userName,
      userPhone,
      productName,
    }),
  });

  const response = await req.json();
  return response;
};
